// Own each request so an older search, refresh or dismissed view cannot replace
// newer scoped results. This helper performs reads only and clears stale counts.
export function loadNightQueue({read, query, onState}) {
  const controller = new AbortController()
  let current = true
  onState({loading: true, data: null, error: ''})
  const finished = Promise.resolve().then(() => current ? read(query, {signal: controller.signal}) : null)
    .then(data => {if (current) onState({loading: false, data, error: ''})})
    .catch(error => {if (current && !controller.signal.aborted) onState({loading: false, data: null, error: error.message || 'The overnight queue could not be read.'})})
  return {finished, cancel: () => {current = false; controller.abort()}}
}
